import React from "react"

import { Tooltip } from "antd"

const PaywallTooltip = ({
  plans,
  addOns,
  size = "default",
  title = "Get access to this feature",
  message = "Please subscribe to a plan or purchase addons from the list given below to unlock feature.",
  children,
}) => {

  return (
    <Tooltip
      className="paywall-tooltip"
      title={title}
    >
      {children}
    </Tooltip>
  )
}

export default PaywallTooltip
